import React from 'react'
import {Editor, EditorState, Modifier, ContentState} from 'draft-js'
import 'draft-js/dist/Draft.css'

import {stripNewlines} from 'lib/utils'

// Single-line, plaintext editor that wraps draft-js. Note that because of the
// way draft.js works, this is analagous to an *uncontrolled* <input> - you can
// read values out, but don't expect to pass values in other than defaultValue
export class SingleLineEditor extends React.Component {
  constructor (props) {
    super(props)

    if (props.defaultValue) {
      var content = ContentState.createFromText(props.defaultValue)
      this.state = {editorState: EditorState.createWithContent(content)}
    } else {
      this.state = {editorState: EditorState.createEmpty()}
    }
  }

  handleReturn = () => {
    if (this.props.onReturn) {
      this.props.onReturn()
    }
    return 'handled' // prevents the user from inserting line breaks with return key
  }

  onChange = (editorState) => {
    this.setState({editorState})
    const {onChange} = this.props
    // only fire props.onChange if the content actually changed
    if (onChange && this._lastContent !== editorState.getCurrentContent()) {
      onChange(editorState.getCurrentContent().getPlainText())
    }
    this._lastContent = editorState.getCurrentContent()
  }

  handlePastedText = (text, html) => {
    const {editorState} = this.state
    const contentState = editorState.getCurrentContent()
    const replaced = Modifier.replaceText(
      contentState,
      editorState.getSelection(),
      stripNewlines(text, ' '))
    const newEditorState = EditorState.push(
      editorState,
      replaced,
      'insert-fragment')
    this.onChange(newEditorState)
    return true
  }

  focus = () => {
    this._editor && this._editor.focus()
  }

  blur = () => {
    this._editor && this._editor.blur()
  }

  setRef = (editor) => {
    this._editor = editor
  }

  render () {
    const {editorState} = this.state
    const {placeholder, textAlignment, spellCheck, onFocus, onBlur} = this.props
    return (
      <Editor
        ref={this.setRef}
        onFocus={onFocus}
        onBlur={onBlur}
        spellCheck={spellCheck}
        editorState={editorState}
        onChange={this.onChange}
        handleReturn={this.handleReturn}
        handlePastedText={this.handlePastedText}
        placeholder={placeholder}
        textAlignment={textAlignment} />
    )
  }
}
